// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.add-box-shadow {
  box-shadow: 2px 2px 5px #000;
}

.btn-close-modal {
  background-color: #ffffff;
  -webkit-background-clip: border-box;
  background-clip: border-box;
  border: 0 solid rgba(0, 0, 0, 0.125);
  border-radius: 0.75rem;
  box-shadow: 0rem 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1), 0rem 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.06);
  overflow: visible;
  padding: 1rem;
}
.btn-close-modal > div {
  margin-top: 0;
}

.data-view-container {
  display: block;
}
.data-view-container .MuiBox-root .css-17mkaxz {
  max-width: -webkit-fit-content;
  max-width: fit-content;
}
.data-view-container > div {
  width: 100%;
}
.data-view-container .data-accordion {
  border-radius: 0.75rem;
  margin-bottom: 5px;
}
.data-view-container .data-accordion:before {
  display: none;
}
.data-view-container .data-accordion:last-of-type {
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.data-view-container .data-view {
  height: 100%;
  width: 100%;
}
.data-view-container .data-view form .lb-xs > label {
  margin-right: 0;
}
.data-view-container .data-view .currency-input {
  background-color: #f5f5f5;
  color: #666;
}
.data-view-container .data-view .currency-input--dark {
  background-color: #424242;
  color: #fff;
}
.data-view-container .activity-logs-container {
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: none;
}
.data-view-container .activity-logs-container--dark {
  background-color: #1a2035;
}
.data-view-container .clear-filters-container {
  display: flex;
  justify-content: flex-end;
}
.data-view-container .clear-filters-container button {
  min-width: 120px;
}
@media (min-width: 1024px) {
  .data-view-container {
    display: flex;
  }
  .data-view-container .data-view {
    width: 88% !important;
    margin: 0 auto;
  }
}

.modal-container {
  overflow-y: auto;
}
.modal-container .data-view {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  padding: 32px;
  max-height: 100%;
  box-shadow: none;
}
.modal-container .data-view .css-1v2oh8h {
  padding: 0;
  margin: 0;
  max-width: 100%;
}
.modal-container .data-view .css-halbs2-MuiButtonBase-root-MuiButton-root {
  margin-top: 0px !important;
  justify-content: flex-end !important;
}
.modal-container .data-view .css-5kxzi1-MuiGrid-root {
  justify-content: flex-start !important;
}
@media (min-width: 768px) {
  .modal-container .data-view {
    width: 90%;
  }
}
@media (min-width: 1024px) {
  .modal-container .data-view {
    width: 80%;
  }
}

.MuiDialogActions-root button + button {
  color: #fff;
}

.pg-viewer-wrapper {
  height: 500px;
}

#react-doc-viewer #header-bar {
  display: none;
}
#react-doc-viewer #proxy-renderer {
  overflow: none;
}
#react-doc-viewer #proxy-renderer #msdoc-renderer iframe {
  height: 500px;
}

.title-modal {
  color: #fff !important;
  text-shadow: 2px 2px 5px #000;
}

.visually-hidden-input {
  clip: rect(0 0 0 0);
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
}

.docx-wrapper {
  background: white;
  padding: 30px;
}
.docx-wrapper section.docx {
  min-height: 500px;
  background: white;
}

@media (min-width: 1024px) {
  ::-webkit-scrollbar {
    width: 20px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
}
.px-xs {
  padding-left: 8px;
  padding-right: 8px;
}

.px-sm {
  padding-left: 12px;
  padding-right: 12px;
}

.px-md {
  padding-left: 16px;
  padding-right: 16px;
}

.px-lg {
  padding-left: 24px;
  padding-right: 24px;
}

.px-xl {
  padding-left: 32px;
  padding-right: 32px;
}

.py-xs {
  padding-top: 8px;
  padding-bottom: 8px;
}

.py-sm {
  padding-top: 12px;
  padding-bottom: 12px;
}

.py-md {
  padding-top: 16px;
  padding-bottom: 16px;
}

.py-lg {
  padding-top: 24px;
  padding-bottom: 24px;
}

.py-xl {
  padding-top: 32px;
  padding-bottom: 32px;
}

.p-xs {
  padding: 8px;
}

.p-sm {
  padding: 12px;
}

.p-md {
  padding: 16px;
}

.p-lg {
  padding: 24px;
}

.p-xl {
  padding: 32px;
}

.text-xs {
  font-size: 0.75rem;
}

.text-sm {
  font-size: 0.875rem;
}

.text-base {
  font-size: 1rem;
}

.text-lg {
  font-size: 1.125rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-2xl {
  font-size: 1.5rem;
}

.text-3xl {
  font-size: 1.875rem;
}

.text-4xl {
  font-size: 2.25rem;
}

.font-normal {
  font-weight: 400;
}

.font-medium {
  font-weight: 500;
}

.font-semibold {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.title-primary {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.2;
}

.title-secondary {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.3;
}

.subtitle {
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.4;
}

.body-text {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
}

.body3 {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
}

.caption {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
}

.card-base {
  padding: 24px;
  border-radius: 12px;
}
@media (max-width: 768px) {
  .card-base {
    padding: 16px;
  }
}

.card-general-content {
  padding: 16px;
}
@media (max-width: 768px) {
  .card-general-content {
    padding: 12px 16px;
  }
}

.card-header-base {
  padding: 16px 24px;
}
@media (max-width: 768px) {
  .card-header-base {
    padding: 12px 16px;
  }
}

.card-content-base {
  padding: 16px 24px;
}
@media (max-width: 768px) {
  .card-content-base {
    padding: 12px 16px;
  }
}

.MuiDialog-paper .MuiDialogTitle-root {
  padding: 16px !important;
}
@media (max-width: 768px) {
  .MuiDialog-paper .MuiDialogTitle-root {
    padding: 12px 16px !important;
  }
}
.MuiDialog-paper .MuiDialogContent-root {
  padding: 16px !important;
}
@media (max-width: 768px) {
  .MuiDialog-paper .MuiDialogContent-root {
    padding: 12px 16px !important;
  }
}
.MuiDialog-paper .MuiDialogActions-root {
  padding: 16px !important;
}
@media (max-width: 768px) {
  .MuiDialog-paper .MuiDialogActions-root {
    padding: 12px 16px !important;
  }
}
.MuiDialog-paper .css-knlq9b-MuiFormControlLabel-root .MuiFormControlLabel-label {
  display: inline-block;
  margin-top: -15px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #344767;
  line-height: 1;
  transform: translateY(0.625rem);
  margin-left: 0.25rem;
}
.MuiDialog-paper .css-cbmr7p-MuiSvgIcon-root {
  -webkit-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  margin-top: 0px;
  display: inline-block;
  fill: currentColor;
  flex-shrink: 0;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.25rem;
  color: #344767;
  font-size: 1.25rem !important;
}
.MuiDialog-paper .css-tnsvld-MuiSwitch-root {
  display: inline-flex;
  width: 58px;
  height: 38px;
  margin-top: 0px;
  overflow: hidden;
  padding: 12px;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  z-index: 0;
  vertical-align: middle;
}
.MuiDialog-paper .css-knlq9b-MuiFormControlLabel-root {
  display: inline-flex;
  /* -webkit-align-items: center; */
  /* -webkit-box-align: center; */
  -ms-flex-align: center;
  /* align-items: center; */
  /* cursor: pointer; */
  /* vertical-align: bottom; */
  /* -webkit-tap-highlight-color: transparent; */
  /* margin-left: -11px; */
  margin-right: 16px;
  /* display: block; */
  /* min-height: 1.5rem; */
  /* margin-bottom: 0.125rem; */
}
.MuiDialog-paper .css-1bg6o37-MuiGrid-root {
  box-sizing: border-box;
  margin: 0;
  flex-direction: row;
  flex-basis: 100%;
  flex-grow: 0;
  /* max-width: 100%; */
}

.css-1ioqvny-MuiPaper-root-MuiDrawer-paper {
  overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/styles/components/_general.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;8HAAA;AAKA;;;;kBAAA;ACLA;;;8HAAA;AAKA;;;;kBAAA;ADQA;EACE,4BAAA;AAOF;;AAJA;EACE,yBAAA;EACA,mCAAA;EACA,2BAAA;EACA,oCAAA;EACA,sBAAA;EACA,qHACE;EAEF,iBAAA;EACA,aAAA;AAKF;AAHE;EACE,aAAA;AAKJ;;AADA;EACE,cAAA;AAIF;AAFE;EACE,8BAAA;EAAA,sBAAA;AAIJ;AADE;EACE,WAAA;AAGJ;AAAE;EACE,sBAAA;EACA,kBAAA;AAEJ;AAAI;EACE,aAAA;AAEN;AACI;EACE,kCAAA;EACA,mCAAA;AACN;AAGE;EACE,YAAA;EACA,WAAA;AADJ;AAKQ;EACE,eAAA;AAHV;AAQI;EACE,yBAAA;EACA,WAAA;AANN;AAQM;EACE,yBAAA;EACA,WAAA;AANR;AAWE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AATJ;AAUI;EACE,yBAAA;AARN;AAWE;EACE,aAAA;EACA,yBAAA;AATJ;AAUI;EACE,gBAAA;AARN;AAYE;EAhEF;IAiEI,aAAA;EATF;EAWE;IACE,qBAAA;IACA,cAAA;EATJ;AACF;;AAaA;EACE,gBAAA;AAVF;AAYE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAVJ;AAYI;EACE,UAAA;EACA,SAAA;EACA,eAAA;AAVN;AAaI;EACE,0BAAA;EACA,oCAAA;AAXN;AAeI;EACE,sCAAA;AAbN;AAgBI;EA1BF;IA2BI,UAAA;EAbJ;AACF;AAeI;EA9BF;IA+BI,UAAA;EAZJ;AACF;;AAiBE;EACE,WAAA;AAdJ;;AAkBA;EACE,aAAA;AAfF;;AAmBE;EACE,aAAA;AAhBJ;AAmBE;EACE,cAAA;AAjBJ;AAoBM;EACE,aAAA;AAlBR;;AAwBA;EACE,sBAAA;EACA,6BAAA;AArBF;;AAwBA;EACE,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,UAAA;AArBF;;AAyBA;EACE,iBAAA;EACA,aAAA;AAtBF;AAwBE;EACE,iBAAA;EACA,iBAAA;AAtBJ;;AA0BA;EACE;IACE,WAAA;EAvBF;EA0BA;IACE,6BAAA;EAxBF;EA2BA;IACE,sBAAA;IACA,mBAAA;IACA,6BAAA;IACA,4BAAA;EAzBF;EA4BA;IACE,sBAAA;EA1BF;AACF;AAkCA;EACE,iBC3MW;ED4MX,kBC5MW;AD4Kb;;AAmCA;EACE,kBC/MW;EDgNX,mBChNW;ADgLb;;AAmCA;EACE,kBCnNW;EDoNX,mBCpNW;ADoLb;;AAmCA;EACE,kBCvNW;EDwNX,mBCxNW;ADwLb;;AAmCA;EACE,kBC3NW;ED4NX,mBC5NW;AD4Lb;;AAoCA;EACE,gBCrOW;EDsOX,mBCtOW;ADqMb;;AAoCA;EACE,iBCzOW;ED0OX,oBC1OW;ADyMb;;AAoCA;EACE,iBC7OW;ED8OX,oBC9OW;AD6Mb;;AAoCA;EACE,iBCjPW;EDkPX,oBClPW;ADiNb;;AAoCA;EACE,iBCrPW;EDsPX,oBCtPW;ADqNb;;AAqCA;EACE,YC/PW;AD6Nb;;AAqCA;EACE,aClQW;ADgOb;;AAqCA;EACE,aCrQW;ADmOb;;AAqCA;EACE,aCxQW;ADsOb;;AAqCA;EACE,aC3QW;ADyOb;;AA0CA;EACE,kBCjRQ;AD0OV;;AA0CA;EACE,mBCpRQ;AD6OV;;AA0CA;EACE,eCtRU;AD+OZ;;AA0CA;EACE,mBCzRQ;ADkPV;;AA0CA;EACE,kBC5RQ;ADqPV;;AA0CA;EACE,iBC/RS;ADwPX;;AA0CA;EACE,mBClSS;AD2PX;;AA0CA;EACE,kBCrSS;AD8PX;;AA2CA;EACE,gBCvSY;AD+Pd;;AA2CA;EACE,gBC1SY;ADkQd;;AA2CA;EACE,gBC7Sc;ADqQhB;;AA2CA;EACE,gBChTU;ADwQZ;;AA4CA;EACE,iBC7TS;ED8TT,gBCtTU;EDuTV,gBAAA;AAzCF;;AA4CA;EACE,kBCpUQ;EDqUR,gBC5TU;ED6TV,gBAAA;AAzCF;;AA4CA;EACE,mBC3UQ;ED4UR,gBClUU;EDmUV,gBAAA;AAzCF;;AA4CA;EACE,eClVU;EDmVV,gBCxUU;EDyUV,gBAAA;AAzCF;;AA4CA;EACE,mBC1VQ;ED2VR,gBChVY;EDiVZ,cAAA;AAzCF;;AA4CA;EACE,mBChWQ;EDiWR,gBCvVY;EDwVZ,gBAAA;AAzCF;;AAiDA;EACE,aChXW;EDiXX,mBAAA;AA9CF;AAgDE;EAJF;IAKI,aCrXS;EDwUX;AACF;;AAgDA;EACE,aC1XW;AD6Ub;AA+CE;EAHF;IAII,kBAAA;EA5CF;AACF;;AA+CA;EACE,kBAAA;AA5CF;AA8CE;EAHF;IAII,kBAAA;EA3CF;AACF;;AA8CA;EACE,kBAAA;AA3CF;AA6CE;EAHF;IAII,kBAAA;EA1CF;AACF;;AAmDE;EACE,wBAAA;AAhDJ;AAkDI;EAHF;IAII,6BAAA;EA/CJ;AACF;AAkDE;EACE,wBAAA;AAhDJ;AAkDI;EAHF;IAII,6BAAA;EA/CJ;AACF;AAkDE;EACE,wBAAA;AAhDJ;AAkDI;EAHF;IAII,6BAAA;EA/CJ;AACF;AAkDE;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EAIA,+BAAA;EACA,oBAAA;AAhDJ;AAmDE;EACE,yBAAA;EAGA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EAGA,cAAA;EAEA,uDAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;AAjDJ;AAoDE;EAIE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EAGA,cAAA;EACA,UAAA;EACA,sBAAA;AAlDJ;AAqDE;EAIE,oBAAA;EACA,iCAAA;EACA,+BAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,8CAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,6BAAA;AAnDJ;AAsDE;EACE,sBAAA;EACA,SAAA;EAGA,mBAAA;EAGA,gBAAA;EAIA,YAAA;EACA,qBAAA;AApDJ;;AAwDA;EACE,kBAAA;AArDF","sourcesContent":["/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../_variables\" as vars;\n\n.add-box-shadow {\n  box-shadow: 2px 2px 5px vars.$color-black;\n}\n\n.btn-close-modal {\n  background-color: #ffffff;\n  -webkit-background-clip: border-box;\n  background-clip: border-box;\n  border: 0 solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.75rem;\n  box-shadow:\n    0rem 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1),\n    0rem 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.06);\n  overflow: visible;\n  padding: 1rem;\n\n  >div {\n    margin-top: 0;\n  }\n}\n\n.data-view-container {\n  display: block;\n\n  .MuiBox-root .css-17mkaxz{\n    max-width: fit-content;\n  }\n\n  >div {\n    width: 100%;\n  }\n\n  .data-accordion {\n    border-radius: 0.75rem;\n    margin-bottom: 5px;\n\n    &:before {\n      display: none;\n    }\n\n    &:last-of-type {\n      border-bottom-left-radius: 0.75rem;\n      border-bottom-right-radius: 0.75rem;\n    }\n  }\n\n  .data-view {\n    height: 100%;\n    width: 100%;\n\n    form {\n      .lb-xs {\n        >label {\n          margin-right: 0;\n        }\n      }\n    }\n\n    .currency-input {\n      background-color: #f5f5f5;\n      color: #666;\n\n      &--dark {\n        background-color: #424242;\n        color: #fff;\n      }\n    }\n  }\n\n  .activity-logs-container{\n    padding: 16px;\n    margin-bottom: 16px;\n    box-shadow: none;\n    &--dark {\n      background-color: #1a2035\n    }\n  }\n  .clear-filters-container{\n    display: flex;\n    justify-content: flex-end;\n    button {\n      min-width: 120px;\n    }\n  }\n\n  @media (min-width: vars.$md-media-querys) {\n    display: flex;\n\n    .data-view {\n      width: 88% !important;\n      margin: 0 auto;\n    }\n  }\n}\n\n.modal-container {\n  overflow-y: auto;\n\n  .data-view {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    padding: 32px;\n    max-height: 100%;\n    box-shadow: none;\n\n    .css-1v2oh8h {\n      padding: 0;\n      margin: 0;\n      max-width: 100%;\n    }\n\n    .css-halbs2-MuiButtonBase-root-MuiButton-root {\n      margin-top: 0px !important;\n      justify-content: flex-end !important;\n\n    }\n\n    .css-5kxzi1-MuiGrid-root {\n      justify-content: flex-start !important;\n    }\n\n    @media (min-width: vars.$sm-media-querys) {\n      width: 90%;\n    }\n\n    @media (min-width: vars.$md-media-querys) {\n      width: 80%;\n    }\n  }\n}\n\n.MuiDialogActions-root {\n  button+button {\n    color: #fff;\n  }\n}\n\n.pg-viewer-wrapper {\n  height: 500px;\n}\n\n#react-doc-viewer {\n  #header-bar {\n    display: none;\n  }\n\n  #proxy-renderer {\n    overflow: none;\n\n    #msdoc-renderer {\n      iframe {\n        height: 500px;\n      }\n    }\n  }\n}\n\n.title-modal {\n  color: #fff !important;\n  text-shadow: 2px 2px 5px vars.$color-black;\n}\n\n.visually-hidden-input {\n  clip: rect(0 0 0 0);\n  -webkit-clip-path: inset(50%);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  white-space: nowrap;\n  width: 1px;\n}\n\n// Styles for docx-preview\n.docx-wrapper {\n  background: white;\n  padding: 30px;\n\n  section.docx {\n    min-height: 500px;\n    background: white;\n  }\n}\n\n@media (min-width: vars.$md-media-querys) {\n  ::-webkit-scrollbar {\n    width: 20px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: #888;\n    border-radius: 20px;\n    border: 6px solid transparent;\n    background-clip: content-box;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background-color: #555;\n  }\n}\n\n// ========================================\n// Utility Classes - Padding System\n// ========================================\n\n// Padding horizontal (left and right)\n.px-xs {\n  padding-left: vars.$padding-xs;\n  padding-right: vars.$padding-xs;\n}\n\n.px-sm {\n  padding-left: vars.$padding-sm;\n  padding-right: vars.$padding-sm;\n}\n\n.px-md {\n  padding-left: vars.$padding-md;\n  padding-right: vars.$padding-md;\n}\n\n.px-lg {\n  padding-left: vars.$padding-lg;\n  padding-right: vars.$padding-lg;\n}\n\n.px-xl {\n  padding-left: vars.$padding-xl;\n  padding-right: vars.$padding-xl;\n}\n\n// Padding vertical (top and bottom)\n.py-xs {\n  padding-top: vars.$padding-xs;\n  padding-bottom: vars.$padding-xs;\n}\n\n.py-sm {\n  padding-top: vars.$padding-sm;\n  padding-bottom: vars.$padding-sm;\n}\n\n.py-md {\n  padding-top: vars.$padding-md;\n  padding-bottom: vars.$padding-md;\n}\n\n.py-lg {\n  padding-top: vars.$padding-lg;\n  padding-bottom: vars.$padding-lg;\n}\n\n.py-xl {\n  padding-top: vars.$padding-xl;\n  padding-bottom: vars.$padding-xl;\n}\n\n// Padding all sides\n.p-xs {\n  padding: vars.$padding-xs;\n}\n\n.p-sm {\n  padding: vars.$padding-sm;\n}\n\n.p-md {\n  padding: vars.$padding-md;\n}\n\n.p-lg {\n  padding: vars.$padding-lg;\n}\n\n.p-xl {\n  padding: vars.$padding-xl;\n}\n\n// ========================================\n// Typography System\n// ========================================\n\n// Text sizes\n.text-xs {\n  font-size: vars.$text-xs;\n}\n\n.text-sm {\n  font-size: vars.$text-sm;\n}\n\n.text-base {\n  font-size: vars.$text-base;\n}\n\n.text-lg {\n  font-size: vars.$text-lg;\n}\n\n.text-xl {\n  font-size: vars.$text-xl;\n}\n\n.text-2xl {\n  font-size: vars.$text-2xl;\n}\n\n.text-3xl {\n  font-size: vars.$text-3xl;\n}\n\n.text-4xl {\n  font-size: vars.$text-4xl;\n}\n\n// Font weights\n.font-normal {\n  font-weight: vars.$font-normal;\n}\n\n.font-medium {\n  font-weight: vars.$font-medium;\n}\n\n.font-semibold {\n  font-weight: vars.$font-semibold;\n}\n\n.font-bold {\n  font-weight: vars.$font-bold;\n}\n\n// Common text combinations\n.title-primary {\n  font-size: vars.$text-2xl;\n  font-weight: vars.$font-bold;\n  line-height: 1.2;\n}\n\n.title-secondary {\n  font-size: vars.$text-xl;\n  font-weight: vars.$font-bold;\n  line-height: 1.3;\n}\n\n.subtitle {\n  font-size: vars.$text-lg;\n  font-weight: vars.$font-bold;\n  line-height: 1.4;\n}\n\n.body-text {\n  font-size: vars.$text-base;\n  font-weight: vars.$font-bold;\n  line-height: 1.5;\n}\n\n.body3 {\n  font-size: vars.$text-sm;\n  font-weight: vars.$font-medium;\n  line-height: 1;\n}\n\n.caption {\n  font-size: vars.$text-sm;\n  font-weight: vars.$font-normal;\n  line-height: 1.4;\n}\n\n// ========================================\n// Component Base Classes\n// ========================================\n\n// Base card styling with consistent padding\n.card-base {\n  padding: vars.$padding-lg;\n  border-radius: 12px;\n\n  @media (max-width: vars.$sm-media-querys) {\n    padding: vars.$padding-md;\n  }\n}\n\n.card-general-content {\n  padding: vars.$padding-md;\n\n  @media (max-width: vars.$sm-media-querys) {\n    padding: vars.$padding-sm vars.$padding-md;\n  }\n}\n\n.card-header-base {\n  padding: vars.$padding-md vars.$padding-lg;\n\n  @media (max-width: vars.$sm-media-querys) {\n    padding: vars.$padding-sm vars.$padding-md;\n  }\n}\n\n.card-content-base {\n  padding: vars.$padding-md vars.$padding-lg;\n\n  @media (max-width: vars.$sm-media-querys) {\n    padding: vars.$padding-sm vars.$padding-md;\n  }\n}\n\n// ========================================\n// Modal and Dialog Styles\n// ========================================\n\n// Apply consistent padding to all MUI Dialog components\n.MuiDialog-paper {\n  .MuiDialogTitle-root {\n    padding: vars.$padding-md !important;\n\n    @media (max-width: vars.$sm-media-querys) {\n      padding: vars.$padding-sm vars.$padding-md !important;\n    }\n  }\n\n  .MuiDialogContent-root {\n    padding: vars.$padding-md !important;\n\n    @media (max-width: vars.$sm-media-querys) {\n      padding: vars.$padding-sm vars.$padding-md !important;\n    }\n  }\n\n  .MuiDialogActions-root {\n    padding: vars.$padding-md !important;\n\n    @media (max-width: vars.$sm-media-querys) {\n      padding: vars.$padding-sm vars.$padding-md !important;\n    }\n  }\n\n  .css-knlq9b-MuiFormControlLabel-root .MuiFormControlLabel-label {\n    display: inline-block;\n    margin-top: -15px;\n    font-size: 0.750rem;\n    font-weight: 700;\n    color: #344767;\n    line-height: 1;\n    -webkit-transform: translateY(0.0625rem);\n    -moz-transform: translateY(0.625rem);\n    -ms-transform: translateY(0.625rem);\n    transform: translateY(0.625rem);\n    margin-left: 0.25rem;\n  }\n\n  .css-cbmr7p-MuiSvgIcon-root {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    width: 1em;\n    height: 1em;\n    margin-top: 0px;\n    display: inline-block;\n    fill: currentColor;\n    -webkit-flex-shrink: 0;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    font-size: 1.25rem;\n    color: #344767;\n    font-size: 1.25rem !important;\n  }\n\n  .css-tnsvld-MuiSwitch-root {\n    display: -webkit-inline-box;\n    display: -webkit-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    width: 58px;\n    height: 38px;\n    margin-top: 0px;\n    overflow: hidden;\n    padding: 12px;\n    box-sizing: border-box;\n    position: relative;\n    -webkit-flex-shrink: 0;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    z-index: 0;\n    vertical-align: middle;\n  }\n\n  .css-knlq9b-MuiFormControlLabel-root {\n    display: -webkit-inline-box;\n    display: -webkit-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    /* -webkit-align-items: center; */\n    /* -webkit-box-align: center; */\n    -ms-flex-align: center;\n    /* align-items: center; */\n    /* cursor: pointer; */\n    /* vertical-align: bottom; */\n    /* -webkit-tap-highlight-color: transparent; */\n    /* margin-left: -11px; */\n    margin-right: 16px;\n    /* display: block; */\n    /* min-height: 1.5rem; */\n    /* margin-bottom: 0.125rem; */\n  }\n\n  .css-1bg6o37-MuiGrid-root {\n    box-sizing: border-box;\n    margin: 0;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-basis: 100%;\n    -ms-flex-preferred-size: 100%;\n    flex-basis: 100%;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    /* max-width: 100%; */\n  }\n}\n\n.css-1ioqvny-MuiPaper-root-MuiDrawer-paper{\n  overflow-x: hidden;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n//colors\n$color-black: #000;\n$color-white: #fff;\n$color-gray-light: #f5f5f5;\n$color-gray-dark: #717171;\n$dark-form-backcolor: #1e1532;\n$light-form-backcolor: #ffffff;\n\n//media query\n$xs-media-querys: 320px;\n$sm-media-querys: 768px;\n$md-media-querys: 1024px;\n$lg-media-querys: 1440px;\n\n// Padding variables - Sistema uniforme de espaciado\n$padding-xs: 8px;\n$padding-sm: 12px;\n$padding-md: 16px;\n$padding-lg: 24px;\n$padding-xl: 32px;\n\n// Typography sizes - Tamaños uniformes de texto\n$text-xs: 0.75rem; // 12px - Captions, labels pequeños\n$text-sm: 0.875rem; // 14px - Body text pequeño\n$text-md: 0.9375rem; // 15px - Body text mediano\n$text-base: 1rem; // 16px - Body text normal\n$text-lg: 1.125rem; // 18px - Body text grande\n$text-xl: 1.25rem; // 20px - Subtítulos pequeños\n$text-2xl: 1.5rem; // 24px - Subtítulos\n$text-3xl: 1.875rem; // 30px - Títulos\n$text-4xl: 2.25rem; // 36px - Títulos grandes\n\n// Font weights\n$font-normal: 400;\n$font-medium: 500;\n$font-semibold: 600;\n$font-bold: 700;\n\n// Border radius\n$border-radius-sm: 0.25rem; // 4px\n$border-radius-md: 0.5rem; // 8px\n$border-radius-lg: 1rem; // 16px"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
